import React, { memo } from "react";
import { Link } from "react-router-dom";

const MenuItem = memo(
  ({
    to,
    icon: Icon,
    label,
    isActive,
    isDarkMode,
    badge,
    isNew,
    isCollapsed,
    level = 0,
    isMobile = false,
    onItemClick,
  }) => (
    <Link
      to={to}
      className={`
        group flex items-center ${isCollapsed && !isMobile ? "justify-center" : ""} gap-3 px-4 py-3 rounded-lg transition-all
        ${level > 0 && !isCollapsed ? "ml-4" : ""}
        ${
          isDarkMode
            ? isActive
              ? "bg-brand-logo-purple/20 text-brand-logo-purple border-r-2 border-brand-logo-purple shadow-lg shadow-brand-logo-purple/25"
              : "text-gray-300 hover:bg-brand-logo-purple/10 hover:text-brand-logo-purple"
            : isActive
            ? "bg-primary/10 text-primary"
            : "text-base-content hover:bg-base-200"
        }
      `}
      aria-current={isActive ? "page" : undefined}
      title={isCollapsed && !isMobile ? label : undefined}
      onClick={() => {
        if (isMobile && onItemClick) {
          onItemClick();
        }
      }}
    >
      <div className="relative">
        <Icon
          size={isCollapsed && !isMobile ? 22 : 18}
          className="transition-all duration-200"
          color={isActive ? (isDarkMode ? "#8B5CF6" : "#4f46e5") : undefined}
        />
      </div>

      {(!isCollapsed || isMobile) && (
        <>
          <span className="font-medium transition-transform duration-200 group-hover:translate-x-0.5">
            {label}
          </span>

          {badge && (
            <span
              className={`ml-auto px-2 py-0.5 text-xs rounded-full ${
                isDarkMode
                  ? "bg-blue-500/20 text-blue-300"
                  : "bg-primary/20 text-primary"
              }`}
            >
              {badge}
            </span>
          )}

          {isNew && (
            <span
              className={`ml-auto px-2 py-0.5 text-xs rounded-full ${
                isDarkMode
                  ? "bg-emerald-500/20 text-emerald-300"
                  : "bg-emerald-500/20 text-emerald-600"
              } animate-pulse`}
            >
              New
            </span>
          )}
        </>
      )}

      {isCollapsed && !isMobile && badge && (
        <span
          className={`absolute top-1 right-1 w-4 h-4 flex items-center justify-center text-xs rounded-full ${
            isDarkMode
              ? "bg-blue-500 text-white"
              : "bg-primary text-primary-content"
          }`}
        >
          {typeof badge === "string" && badge.length <= 2 ? badge : "•"}
        </span>
      )}

      {isCollapsed && !isMobile && isNew && !badge && (
        <span
          className={`absolute top-1 right-1 w-2 h-2 rounded-full ${
            isDarkMode
              ? "bg-emerald-500"
              : "bg-emerald-500"
          } animate-pulse`}
        ></span>
      )}
    </Link>
  )
);

export default MenuItem; 